<template>
  <div class="charge-balance">
    <span class="amount">Saldo disponível <span :class="['badge', statusVariant]">R$ {{ formatPrice(balance) }}</span></span>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import { EventBus } from '@/services/event-bus'

export default {
  name: 'ChargeBalance',
  data () {
    return {
      balance: null,
      statusVariant: 'badge-danger'
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.getBalance()
      EventBus.$on('charge-added', chargeAmount => {
        if (chargeAmount) {
          this.balance = parseFloat(this.balance) + parseFloat(chargeAmount)
          this.toogleVariant()
        }
      })
      EventBus.$on('reload-balance', () => {
        this.getBalance()
      })
    })
  },
  methods: {
    getBalance () {
      setTimeout(_ => {
        if (this.$store.state.auth && this.$store.state.auth.user) {
          loopback
            .get('/credits/balance')
            .then(response => {
              if (response.status === 200) {
                this.balance = response.balance
                this.toogleVariant()
              }
            })
        }
      }, 1000)
    },
    toogleVariant () {
      if (this.balance <= 0) {
        this.statusVariant = 'badge-danger'
      } else if (this.balance > 0 && this.balance <= 10) {
        this.statusVariant = 'badge-warning'
      } else if (this.balance > 10) {
        this.statusVariant = 'badge-success'
      } else {
        this.statusVariant = 'badge-secondary'
      }
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  }
}
</script>

<style lang="scss" scoped>
.badge {
  vertical-align: middle;
}
.balance {
  .amount {
    font-size: 16px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Charge/Balance.vue